(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('CampagnaDialogController', CampagnaDialogController);


    CampagnaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Campagna', 'Agenzia', 'CampagnaStatus', 'Campagna_type', 'User'];

    function CampagnaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Campagna, Agenzia, CampagnaStatus, Campagna_type, User) {

        var vm = this;

        vm.campagna = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.agenzias = Agenzia.query();
        vm.campagna_statuses = CampagnaStatus.query();
        vm.campagna_types = Campagna_type.query();
        vm.campagna_users = User.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.campagna.id !== null) {
                Campagna.update(vm.campagna, onSaveSuccess, onSaveError);
            } else {
                Campagna.save(vm.campagna, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:campagnaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtStart = false;
        vm.datePickerOpenStatus.dtEnd = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
